export default __webpack_public_path__ + "d0ab86baef65d51370436ab156beafd3.png";